export default __webpack_public_path__ + "static/media/room.c7bd05d3.png";